import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';
import { AppStorage } from './app.storage';

// export const BASE_URL_INITIAL_BALANCE = environment.BASE_URL_INITIAL_BALANCE;
// export const BASE_URL_REPORT = environment.BASE_URL_REPORT;
export const BASE_URL_REPORTS = environment.BASE_URL_REPORTS;
export const BASE_URL_CRUD = environment.BASE_URL_CRUD;
export const BASE_URL_BULK_UPLOAD = environment.BASE_URL_BULK_UPLOAD;
export const BASE_URL_MESSAGE = environment.BASE_URL_MESSAGE;
export const BASE_URL_SSO = environment.BASE_URL_SSO;
export const BASE_URL_KASTOR = environment.BASE_URL_KASTOR;
// export const BASE_URL_KIUNGO = environment.BASE_URL_KIUNGO;
export const BASE_URL_TRANSLATION = environment.BASE_URL_TRANSLATION;
export const REALM = environment.REALM;
export const SENTRY_DSN = environment.SENTRY_DSN;
export const BASE_URL_INTEGRATION = environment.BASE_URL_INTEGRATION;

@Injectable()
export class AppService extends AppStorage {
  public endpoint = '/';

  constructor(public http: HttpClient) {
    super();
  }

  createAuthorizationHeader(): HttpHeaders {
    let token = '';
    if (localStorage.getItem('currentUser')) {
      token = JSON.parse(localStorage.getItem('currentUser')).access_token;
    }
    let headers = null;
    if (token) {
      headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token });
    } else {
      headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    return headers;
  }

  get<type>(url: any, accessToken: string = null) {
    const headers = this.createAuthorizationHeader();
    return this.http.get<type>(url, { headers: headers, responseType: 'json' }).catch((err: any, caught: Observable<any>) => {
      return Observable.throw(err);
    });
  }

  post<type>(url: any, data: any, accessToken: string = null) {
    const headers = this.createAuthorizationHeader();
    return this.http.post<type>(url, data, {
      headers: headers, responseType: 'json'
    }).catch((err: any, caught: Observable<any>) => {
      return Observable.throw(err);
    });
  }

  create<type>(url: any, data: any, type: any = 'json') {
    const headers = this.createAuthorizationHeader();
    return this.http.post<type>(url, data, {
      headers: headers, responseType: type,
    }).catch((err: any, caught: Observable<any>) => {
      return Observable.throw(err);
    });
  }

  update<type>(url: any, data: any) {
    const headers = this.createAuthorizationHeader();
    return this.http.put<type>(url, data, {
      headers: headers,
    }).catch((err: any, caught: Observable<any>) => {
      return Observable.throw(err);
    });
  }

  remove<type>(url: any) {
    const headers = this.createAuthorizationHeader();
    return this.http.delete<type>(url, {
      headers: headers, responseType: 'json'
    }).catch((err: any, caught: Observable<any>) => {
      return Observable.throw(err);
    });
  }

  createSSO(url: string, data: any, accessToken: string = null): Observable<any> {
    const headers = this.createAuthorizationHeader();
    return this.http.post(url, this._prepare(data), { headers: headers, responseType: 'json' });
  }

  patch(url, data: any, accessToken: string = null): Observable<any> {
    const headers = this.createAuthorizationHeader();
    return this.http.patch(url, this._prepare(data), { headers: headers, responseType: 'json' });
  }

  generate(url: string, data: any): Observable<any> {
    const headers = this.createAuthorizationHeader();
    return this.http.post(url, data, {
      headers: headers,
      responseType: 'blob',
    });
  }

  upload(url: string, formData: FormData): Observable<any> {
    const headers = this.createAuthorizationHeader();
    return this.http.post(url, formData, { headers: headers });
  }

  handleError(error: any): Observable<any> {
    console.log('An error occurred', error);
    return Observable.throw(error.message || error);
  }

  private _prepare(data: any) {
    return (data instanceof Array || data instanceof Object) ? JSON.stringify(data) : data;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.service.ts